import {
    GET_SELECTED_ACTION_SOCIALE,
    GET_ALL_ACTION_SOCIALE,
    GET_SELECTED_EXERCICE,
    GET_FICHE,
    GET_OPT_JUSTIFICATIF,
    GET_MAX_VAL_PRESTATION,
    GET_IBAN,
    GET_PAC,
    GET_PARAMS_ENFANT,
    GET_FULL_ACTION_SOCIALE,
    GET_CESU_MULTI_TAUX
} from "./types";

export const setCAS = (selectedActionSociale) => (dispatch) => {
    dispatch({
        type: GET_SELECTED_ACTION_SOCIALE,
        payload: { cas: selectedActionSociale },
    });
};

export const setASExercice = (selectedExercice) => (dispatch) => {
    dispatch({
        type: GET_SELECTED_EXERCICE,
        payload: { exercice: selectedExercice },
    });
};

export const setFiche = (fiche) => (dispatch) => {
    dispatch({
        type: GET_FICHE,
        payload: { fiche: fiche },
    });
};

export const setOptJustificatif = (isRequired) => (dispatch) => {
    dispatch({
        type: GET_OPT_JUSTIFICATIF,
        payload: { optJustificatif: isRequired },
    });
};

export const setIban = (iban) => (dispatch) => {
    dispatch({
        type: GET_IBAN,
        payload: { iban: iban },
    });
};

export const setMaxVal = (val) => (dispatch) => {
    dispatch({
        type: GET_MAX_VAL_PRESTATION,
        payload: { maxVal: val },
    });
};

export const setPac = (enfants) => (dispatch) => {
    dispatch({
        type: GET_PAC,
        payload: { enfants: enfants },
    });
};

export const setListActionSociale = (actionSocialeList) => (dispatch) => {
    dispatch({
        type: GET_ALL_ACTION_SOCIALE,
        payload: { listActionsSociale: actionSocialeList },
    });
};

export const setFullActionSociale = (actionSociale) => (dispatch) => {
    dispatch({
        type: GET_FULL_ACTION_SOCIALE,
        payload: { actionSociale: actionSociale },
    });
};

export const setParamsEnfants = (paramsEnfants) => (dispatch) => {
    dispatch({
        type: GET_PARAMS_ENFANT,
        payload: { paramsEnfants: paramsEnfants },
    });
};


export const setCesuMultiMontantTaux = (cesuMultiTaux) => (dispatch) => {
    dispatch({
        type: GET_CESU_MULTI_TAUX,
        payload: { cesuMultiTaux: cesuMultiTaux },
    });
};
